var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isShop)?_c('div',{staticClass:"logo",on:{"click":_vm.backToIndex}},[_c('div',{staticClass:"image"})]):_c('div',{staticClass:"logo",on:{"click":_vm.backToShop}},[_c('div',{staticClass:"image image-shop"})])}
var staticRenderFns = []

export { render, staticRenderFns }